import { Routes } from '@angular/router';
import { MainLayoutComponent } from './shared/layout/main-layout/main-layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { RegistrationTokenGuard } from './core/guards/registration-token.guard';
import { KNOWLEDGE_BASE_ROLES, METRICS_ROLES, REQUEST_PANEL_BASE_ROLES, USER_BASE_ROLES, WORKSPACE_ROLES } from './core/constants/route-roles.constants';
import { RoleGuard } from './core/guards/role.guard';
import { workspaceExistsGuard } from './core/guards/workspace-exists.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.default),
  },
  {
    path: 'complete-registration/:token',
    canActivate: [RegistrationTokenGuard],
    loadChildren: () => import('./features/register/register.routes').then((m) => m.registerRoutes),
  },
  {
    path: 'veflo-vault',
    component: MainLayoutComponent,
    canMatch: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'chat',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadChildren: () => import('./features/home/home.routes').then((m) => m.routes),
      },
      {
        path: 'notification/requests-panel',
        loadChildren: () => import('./features/notification/notification.routes').then((m) => m.notificationRoutes),
        canMatch: [RoleGuard],
        data: { roles: REQUEST_PANEL_BASE_ROLES },
      },
      {
        path: 'workspace',
        loadChildren: () => import('./features/workspace/workspace.routes').then((m) => m.workspaceRoutes),
        canMatch: [RoleGuard],
        data: { roles: WORKSPACE_ROLES },
      },
      {
        path: 'users',
        loadChildren: () => import('./features/user/user.routes').then((m) => m.userRoutes),
        canMatch: [RoleGuard],
        data: { roles: USER_BASE_ROLES },
      },
      {
        path: 'knowledge-base',
        loadChildren: () => import('./features/knowledge-base/knowledge-base.routes').then((m) => m.knowledgeBaseRoutes),
        canMatch: [RoleGuard],
        data: { roles: KNOWLEDGE_BASE_ROLES },
      },
      {
        path: 'metrics',
        loadChildren: () => import('./features/metrics/metrics.routes').then((m) => m.metricsRoutes),
        canMatch: [RoleGuard],
        data: { roles: METRICS_ROLES },
      },
      {
        path: 'chat',
        loadComponent: () => import('./features/chat/pages/chat-home/chat-home.page').then((m) => m.ChatHomePage),
      },
    ],
  },
  {
    path: 'veflo-vault/:workspace_name/:id',
    loadChildren: () => import('./features/chat/chat.routes').then((m) => m.chatRoutes),
    canMatch: [workspaceExistsGuard],
  },
  {
    path: '**',
    redirectTo: 'auth',
  },
];
